import { render } from "./ChildDocument.vue?vue&type=template&id=266b95c8&ts=true"
import script from "./ChildDocument.vue?vue&type=script&lang=ts"
export * from "./ChildDocument.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__